import { type ImageProps, Img } from '@chakra-ui/react'

import CountBubble from './CountBubble'

function WorldIcon({
  iconUrl,
  primaryColor,
  showBubble = false,
  isDragging = false,
  ...props
}: {
  iconUrl: string
  primaryColor: string
  showBubble?: boolean
  isDragging?: boolean
} & ImageProps): JSX.Element {
  return (
    <>
      <Img
        src={iconUrl}
        width="36px"
        height="36px"
        bg={primaryColor}
        borderRadius="4px"
        boxShadow={isDragging ? '0px 6px 24px rgba(0, 0, 0, 0.75)' : undefined}
        {...props}
      />
      {showBubble ? <CountBubble variant="navbarworld" /> : null}
    </>
  )
}

export default WorldIcon
